
// src/pages/Dashboard/QuickQuote/index.jsx
import React, { useState } from 'react';
import styles from './QuickQuote.module.css';
import FirstPage from './components/FirstPage';
import SecondPage from './components/SecondPage';
import ThirdPage from './components/ThirdPage';

const QuickQuote = () => {
  const [currentPage, setCurrentPage] = useState('first');
  const [tableData, setTableData] = useState([]);
  const [headerValues, setHeaderValues] = useState({ refNo: '', discount: '' });
  const [selectedItemsData, setSelectedItemsData] = useState([]);
  const [quantitiesData, setQuantitiesData] = useState({});
  
  // State for first page - lifted up to maintain persistence
  const [firstPageData, setFirstPageData] = useState({
    headerRefNo: '',
    headerDiscount: '',
    tableData: Array(25).fill().map((_, index) => ({
      id: index + 1,
      casNo: '',
      refNo: '',
      discount: '',
      packSize: { quantity: '' }
    }))
  });

  const handleTransmit = (data, headerData) => {
    setTableData(data);
    setHeaderValues(headerData);
    setCurrentPage('second');
  };

  const handleBackToFirstPage = () => {
    setCurrentPage('first');
  };

  const handleViewSelected = (selectedData, quantities) => {
    setSelectedItemsData(selectedData);
    setQuantitiesData(quantities);
    setCurrentPage('selected');
  };

  const handleBackToSecondPage = () => {
    setCurrentPage('second');
  };

  const handleFirstPageDataChange = (newData) => {
    setFirstPageData(newData);
  };

  const handleClearAll = () => {
    setFirstPageData({
      headerRefNo: '',
      headerDiscount: '',
      tableData: Array(25).fill().map((_, index) => ({
        id: index + 1,
        casNo: '',
        refNo: '',
        discount: '',
        packSize: { quantity: '' }
      }))
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {currentPage === 'first' ? (
          <FirstPage 
            onTransmit={handleTransmit}
            firstPageData={firstPageData}
            onDataChange={handleFirstPageDataChange}
            onClearAll={handleClearAll}
          />
        ) : currentPage === 'second' ? (
          <SecondPage 
            initialData={tableData} 
            headerValues={headerValues}
            onBack={handleBackToFirstPage}
            onViewSelected={handleViewSelected}
          />
        ) : (
          <ThirdPage 
            selectedData={selectedItemsData}
            quantities={quantitiesData}
            onBack={handleBackToSecondPage}
          />
        )}
      </div>
    </div>
  );
};

export default QuickQuote;
